import { createAction } from 'redux-act';
import { IClearCache, IDestroyCache, IGetCache, ISetCache, types } from './types';

export const setCache = createAction<ISetCache>(types.SET_CACHE);
export const getCache = createAction<IGetCache>(types.FETCH_CACHE);
export const clearCache = createAction<IClearCache>(types.CLEAR_CACHE);
export const destroyOneCache = createAction<IDestroyCache>(types.DESTROY_ONE_CACHE);
export const nuke = createAction(types.NUKE);
export const checkAndNuke = createAction(types.CHECK_NUKE_TIME);
